import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { NgbdSortableHeader, SortEvent, } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DashboardService } from '../../../business-services/dashboard.service';
import { ToweinUseService } from '../../../business-services/towein-use.service';
import { Filter } from '../../../business-entities/Filter';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { PagerData } from '../../../business-entities/PagerData';
import { PaginationService } from '../../../services/pagination.service';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { TowedinDealerDetailsComponent } from './towedin-dealer-details/towedin-dealer-details.component';
import { ToweInUsageModel } from '../../../business-entities/towed-in-report-model';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-towed-in-report',
  templateUrl: './towed-in-report.component.html',
})
export class TowedInReportComponent implements OnInit {

  //#region  Variable Declaration
  dropdownSettings: {};
  toweInUsageList: ToweInUsageModel[] = [];
  dataList: ToweInUsageModel[] = [];
  selectedDealers: { dealerId: string }[] = [];
  dealerList: any = [];
  selectedDate: any[] = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  selectedDealer: any;

  //#endregion

  //#region Constructor
  constructor(
    private spinner: NgxSpinnerService,
    private dashboardService: DashboardService,
    private userService: UserDataService,
    private datePipe: DatePipe,
    private toweinUseService: ToweinUseService,
    private pagerService: PaginationService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,

  ) { }

  //#endregion 

  ngOnInit() {
    this.toweinUseService.toweinUserListRequest.startRecordNumber = 0;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'dealerId',
      textField: 'dealerName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 500,
    };
    this.userService.currentUser.subscribe((resUser) => {
      resUser && this.GetDealers(resUser.id);
    });

    let todayDate = new Date();
    let formattedTodayDate = this.datePipe.transform(todayDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(todayDate);
    this.selectedDate.push(todayDate);
    let formatted= formattedTodayDate + ' - ' + formattedTodayDate;
    this.toweinUseService.toweinUserListRequest.selectedDate = formatted;
    this.toweInUsageList = [];
  }

  //#region Component Methods
  async GetDealers(userId) {
    this.spinner.show();
    this.dealerList = await this.dashboardService.GetDealers(userId);
    if (this.dealerList && this.dealerList.length === 1) {
      const singleDealer = this.dealerList[0];
      this.openDealerDetailsDirectly(singleDealer);
    }
    this.spinner.hide();
  }

  private openDealerDetailsDirectly(dealer: any) {
    const modalref = this.modalService.open(TowedinDealerDetailsComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.dealerId = dealer.dealerId;
    modalref.componentInstance.dealerName = dealer.dealerName;
    modalref.componentInstance.selectedDate = this.toweinUseService.toweinUserListRequest.selectedDate;
  }

  async getToweInUsageList() {
    this.spinner.show();
    await this.toweinUseService.getToweInUsageList(this.toweinUseService.toweinUserListRequest)
      .then(
        (response) => {
          this.spinner.hide();
          this.toweInUsageList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            this.totalCount = this.toweInUsageList[0].totalCount;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.toweInUsageList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  onRefreshClick() {
    this.toweInUsageList = [];
    this.getToweInUsageList();
  }

  onDateRangeChanged(event: any) {
    this.selectedDate = (typeof event === 'undefined') ? [] : event;
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    this.toweInUsageList = [];
    let dealers = [];
    if (this.selectedDealers?.length > 0) {
      dealers = this.selectedDealers.map(x => x.dealerId)
    }

    this.toweinUseService.toweinUserListRequest.selectedDealers = dealers;
    if (selectedDateFormatted == "") {
      this.onDateSelectionCleared();
    }
    this.toweinUseService.toweinUserListRequest.selectedDate = selectedDateFormatted;
    this.getToweInUsageList();
  }

  onDateSelectionCleared() {
    let warningmsg = this.translate.instant("lblShowingLastMonthData");
    this.toaster.warning(warningmsg);
    var date = new Date();
    let startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let formattedStartDate = this.datePipe.transform(startDate, 'dd/MM/yyyy');
    let endDate = new Date();
    let formattedEndDate = this.datePipe.transform(endDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(startDate);
    this.selectedDate.push(endDate);
    this.cdr.detectChanges();
  }

  onChangeDealer(dealer: any): void {
    this.toweInUsageList = [];
    let dealers = [];
    if (this.selectedDealers?.length > 0) {
      dealers = this.selectedDealers.map(x => x.dealerId)
    }

    this.toweinUseService.toweinUserListRequest.selectedDealers = dealers;
    this.getToweInUsageList();
  }

  onClearFilter() {
    this.toweInUsageList = [];
    this.toweinUseService.toweinUserListRequest.sortColumn = "";
    this.toweinUseService.toweinUserListRequest.sortDirection = "";
    this.toweinUseService.toweinUserListRequest.selectedDealers = [];
    this.selectedDealers = [];
    this.onDateSelectionCleared();
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    this.toweinUseService.toweinUserListRequest.selectedDate = selectedDateFormatted;
  }

  onScrollDown() {
    if (this.totalCount > this.toweInUsageList?.length) {
      this.toweinUseService.toweinUserListRequest.startRecordNumber = this.toweInUsageList.length
      this.getToweInUsageList();
    }
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.toweinUseService.toweinUserListRequest.sortColumn = column;
    this.toweinUseService.toweinUserListRequest.sortDirection = direction;
    this.toweinUseService.toweinUserListRequest.startRecordNumber = 0;
    this.toweInUsageList = [];
    this.getToweInUsageList();
  }

  onView(item) {

    const modalref = this.modalService.open(TowedinDealerDetailsComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.dealerId = item.dealerId;
    modalref.componentInstance.dealerName = item.dealerName;
    modalref.componentInstance.selectedDate = this.toweinUseService.toweinUserListRequest.selectedDate;
    modalref.result.then((response) => {
      this.onRefreshClick();
    });
  }
  //#endregion

  //#region Export functionality
  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.spinner.hide();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblTowedInReport')}`);
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('portrait');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8, cellPadding: { top: 2, right: 8, bottom: 2, left: 2 } },
      columnStyles: {
        0: { minCellWidth: 20 },
        1: { minCellWidth: 50 },
        2: { minCellWidth: 30, halign: 'right', cellPadding: { top: 2, right: 14, bottom: 2, left: 2 } },
        3: { minCellWidth: 30, halign: 'right', cellPadding: { top: 2, right: 14, bottom: 2, left: 2 } },
        4: { minCellWidth: 32, halign: 'right', cellPadding: { top: 2, right: 14, bottom: 2, left: 2 } }
      },
    });
    doc.save(`${this.translate.instant('lblTowedInReport')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.toweinUseService.toweinUserListRequest.isExport = true;
    await this.toweinUseService.getToweInUsageList(this.toweinUseService.toweinUserListRequest).then((res) => {
      if (!res || res.responseObject.length === 0) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res.responseObject;
    }).finally(() => {
      this.toweinUseService.toweinUserListRequest.isExport = false;
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblDealerName')]: item.dealerName,
      [this.translate.instant('lblAppointments')]: item.totalAppointments,
      [this.translate.instant('lblCheckInCount')]: item.towInCount,
      [this.translate.instant('lblCheckInPercentage')]: `${item.towInPercentage}%`
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblDealerName'),
      this.translate.instant('lblAppointments'),
      this.translate.instant('lblCheckInCount'),
      this.translate.instant('lblCheckInPercentage')
    ];
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
//#endregion